import * as signalR from "@microsoft/signalr"
import {SignalRRequestObject} from "../../../types"

export type DeliverableScanResult = {
  itemId: string
  result: string //"No threats found"
}

export function SignalRFunctions() {
  const connectSignalR = (
    signalRRequest: SignalRRequestObject,
    setUpdateSignalRResult: React.Dispatch<
      React.SetStateAction<DeliverableScanResult | null>
    >,
  ) => {
    const headers = {
      "X-Functions-Key": signalRRequest.faToken || "",
      "Ocp-Apim-Subscription-Key": signalRRequest.apimKey || "",
      "x-userId": signalRRequest.userId || "",
    }

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(signalRRequest.serverUrl, {
        withCredentials: false,
        headers: headers,
        accessTokenFactory: () => signalRRequest.token,
      })
      .build()

    if (!connection.connectionId)
      connection
        .start()
        .then(() => {
          console.log("SignalR connection established")
        })
        .catch((err) => console.error("SignalR connection error: ", err))

    connection.on("FilescanEvent", (data) => {
      setUpdateSignalRResult(data)
    })

    return connection
  }
  return {
    connectSignalR,
  }
}
